import { gsap } from "gsap";

export default function() {
  const ster01 = gsap.timeline();
  const ster02 = gsap.timeline();
  const ster03 = gsap.timeline();
  const ster04 = gsap.timeline();
  const ster05 = gsap.timeline();
  const ster06 = gsap.timeline();

  ster01.to(".js-fva-ster01", { opacity: 0 });
  ster02.to(".js-fva-ster02", { opacity: 0 });
  ster03.to(".js-fva-ster03", { opacity: 0 });
  ster04.to(".js-fva-ster04", { opacity: 0 });
  ster05.to(".js-fva-ster05", { opacity: 0 });
  ster06.to(".js-fva-ster06", { opacity: 0 });

  ster01.to(".js-fva-ster01", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster01.to(".js-fva-ster01", {
    delay: .7,
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });


  ster02.to(".js-fva-ster02", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster02.to(".js-fva-ster02", {
    delay: 0.5,
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });


  ster03.to(".js-fva-ster03", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster03.to(".js-fva-ster03", {
    delay: 0.3,
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });


  ster04.to(".js-fva-ster04", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster04.to(".js-fva-ster04", {
    delay: 1,
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });


  ster05.to(".js-fva-ster05", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster05.to(".js-fva-ster05", {
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });


  ster06.to(".js-fva-ster06", {
    delay: 5.5,
    opacity: 1,
    duration: 1,
  });

  ster06.to(".js-fva-ster06", {
    opacity: 0,
    duration: 1,
    yoyo: true,
    repeat: -1
  });
}
